<template>
  <div class="fill-height paper-background">
    <transition mode="out-in">
      <!-- loaded -->
      <v-row v-if="Artist && Artist._slug === slug" key="loaded" no-gutters class="pt-md-14 pt-md-0">
        <MomentumScrolling :content-classes="{'paper-background': true, 'scrolling-content': true}" @scroll="scroll = $event">
          <ClipMask v-if="$vuetify.breakpoint.mdAndUp" class="full" key="clip-mask" ref="clip" :label="Artist.name" />
          <Scribbles :num="8" />
          <v-col cols="12" md="6" offset-md="3" class="px-0 px-md-0">
            <div class="artist-content">
              <h1 class="display-4 px-8 px-md-0 text-md-center" ref="title">{{Artist.name}}</h1>
              <div class="social pb-md-16" ref="social">
                <v-row align="center" justify="center">
                  <v-col cols="12" class="pt-4 pb-12 pl-5 pl-md-0 text-md-center">
                    <SocialRepeater :data="Artist.social" />
                  </v-col>
                  <v-col cols="12" class="px-8" v-if="$vuetify.breakpoint.smAndDown && this.Artist._referents.ExhibitionReferents.items.length">
                    <v-btn text small
                      :to="{name: 'PhotoExhibition', params: {slug: this.Artist._referents.ExhibitionReferents.items[0]._slug , artist: this.Artist._slug, index: null}}"
                      class="text-script pb-12" data-cursor-target="gallery|center center">Gallery<NextIcon class="ml-8 next-icon" /></v-btn>
                  </v-col>
                </v-row>
              </div>
              <div class="content" ref="content">
                <component v-for="(block, i) in Artist.content" :is="blocks[block._repeaterType]" :key="i" :data="block" />
              </div>
            </div>
          </v-col>
          <v-col cols="12" class="text-md-center pb-16 pb-md-0" v-if="this.Artist._referents.ExhibitionReferents.totalCount > 0">
            <v-btn  v-if="$vuetify.breakpoint.smAndDown && this.Artist._referents.ExhibitionReferents.items.length" text small
                      :to="{name: 'PhotoExhibition', params: {slug: this.Artist._referents.ExhibitionReferents.items[0]._slug , artist: this.Artist._slug, index: null}}"
                      class="text-script pb-12" data-cursor-target="gallery|center center">Gallery<NextIcon class="ml-8 next-icon" /></v-btn>
            <v-btn v-else text small :to="{name: 'PhotoExhibition', params: {slug: this.Artist._referents.ExhibitionReferents.items[0]._slug , artist: this.Artist._slug, index: null}}" class="text-script py-16" data-cursor-target="gallery|center center">Gallery</v-btn>
          </v-col>
          <v-col cols="12" class="text-center" v-else-if="this.Artist._referents.SpecialProjectReferents.totalCount > 0">
            <v-btn text small :to="{name: 'SpecialProject', params: {slug: this.Artist._referents.SpecialProjectReferents.items[0]._slug , type: this.Artist._referents.SpecialProjectReferents.items[0].type}}" class="text-script py-16" data-cursor-target="next|center center">The Project</v-btn>
          </v-col>
          <!-- <v-col cols="12" class="text-center">
            <v-btn text small :to="{name: 'Artists', params: {slug: this.Artist._referents.ExhibitionReferents.items[0]._slug}}" class="text-script py-16" data-cursor-target="list|center center">The artists</v-btn>
          </v-col> -->
        </MomentumScrolling>
        <transition>
          <v-btn text small v-if="$vuetify.breakpoint.mdAndUp && previousArtist && scroll < 200" :to="{params: {slug: previousArtist._slug}}" class="text-script prev-artist-btn" data-cursor-target="previous">{{previousArtist.name}}</v-btn>
        </transition>
        <transition>
          <v-btn text small v-if="$vuetify.breakpoint.mdAndUp && nextArtist && scroll < 200" :to="{params: {slug: nextArtist._slug}}" class="text-script next-artist-btn" data-cursor-target="previous||1|180">{{nextArtist.name}}</v-btn>
        </transition>
        <v-btn text small exact  v-if="$vuetify.breakpoint.mdAndUp && this.Artist._referents.ExhibitionReferents.totalCount > 0" :to="{name: 'Artists',params: {slug: this.Artist._referents.ExhibitionReferents.items[0]._slug, artist: null}}" class="text-script bottom-left-btn" data-cursor-target="back|center center">The Artists</v-btn>
        <v-btn text small exact  v-if="$vuetify.breakpoint.mdAndUp && this.Artist._referents.SpecialProjectReferents.totalCount > 0" :to="{name: 'SpecialProjectsArtists'}" class="text-script bottom-left-btn" data-cursor-target="back|center center">The Artists</v-btn>
      </v-row>
      <!-- loading -->
      <v-row v-else class="fill-height" align="center" justify="center" key="loading">
        <Scribbles />
        <v-col cols="auto" >
          <div class="animated-eye" />
        </v-col>
      </v-row>
    </transition>
  </div>
</template>

<script>
// eslint-disable-next-line
import gsap from 'gsap'
import MomentumScrolling from '@/atoms/MomentumScrolling'
import GetArtist from '@/graphql/GetArtist.gql'
import SocialRepeater from '@/atoms/SocialRepeater'
import ContentImage from '@/atoms/ContentImage'
import ContentParagraphWithTitle from '@/atoms/ContentParagraphWithTitle'
import ClipMask from '@/molecules/ClipMask'
import uniqBy from 'lodash/uniqBy'
import findIndex from 'lodash/findIndex'
import delay from 'lodash/delay'
import NextIcon from '@/assets/img/next-icon.svg'

import Scribbles from '@/molecules/Scribbles'

export default {
  name: 'Artist',
  components: {
    SocialRepeater,
    MomentumScrolling,
    Scribbles,
    ClipMask,
    NextIcon
  },
  data () {
    return {
      scroll: 0,
      blocks: {
        Image: ContentImage,
        Paragraph: ContentParagraphWithTitle
      }
    }
  },
  props: {
    slug: {
      required: true,
      type: String
    }
  },
  computed: {
    previousArtist () {
      if (this.Artist && this.Artist._referents.ExhibitionReferents.totalCount > 0) {
        let exhibitionArtists = this.Artist._referents.ExhibitionReferents.items[0].photos.map(p => p.artist)
        exhibitionArtists = uniqBy(exhibitionArtists, 'id')

        const thisIndex = findIndex(exhibitionArtists, { id: this.Artist.id })
        return exhibitionArtists[this.absmod(thisIndex - 1, exhibitionArtists.length)]
      }
      return null
    },
    nextArtist () {
      if (this.Artist && this.Artist._referents.ExhibitionReferents.totalCount > 0) {
        let exhibitionArtists = this.Artist._referents.ExhibitionReferents.items[0].photos.map(p => p.artist)
        exhibitionArtists = uniqBy(exhibitionArtists, 'id')

        const thisIndex = findIndex(exhibitionArtists, { id: this.Artist.id })
        return exhibitionArtists[this.absmod(thisIndex + 1, exhibitionArtists.length)]
      }
      return null
    }
  },
  methods: {
    absmod (n, m) {
      return ((n % m) + m) % m
    },
    doTransitionIn () {
      const { title, social, content, clip } = this.$refs
      const arrayToAnimate = []
      if (title) arrayToAnimate.push(title)
      if (social) arrayToAnimate.push(social)
      if (content) arrayToAnimate.push(content)

      if (clip) {
        gsap.set(clip.$el, { scale: 1.2, opacity: 0 })
        gsap.to(clip.$el, {
          duration: 4,
          scale: 1,
          opacity: 1,
          ease: 'expo.out'
        })
      }

      gsap.to(arrayToAnimate, {
        delay: 0.25,
        duration: 2,
        ease: 'quint.out',
        alpha: 1,
        y: 0,
        stagger: 0.1
      })
    }
  },
  destroyed () {
    this.$root.sponsorLogo = null
  },
  apollo: {
    Artist: {
      query: GetArtist,
      variables () {
        return {
          status: 'PUBLISHED',
          slug: this.slug
        }
      },
      async result () {
        console.log(this.Artist)
        if (this.$route.hash) {
          delay(() => {
            this.doTransitionIn()
            this.$vuetify.goTo(this.$route.hash)
          }, 500)
        } else {
          delay(this.doTransitionIn, 700)
          this.$root.$emit('scroll-to-saved-position')
        }

        if (this.Artist._referents.SpecialProjectReferents.items[0]) {
          this.$root.sponsorLogo = this.Artist._referents.SpecialProjectReferents.items[0].logo
        }
      }
    }
  },
  metaInfo () {
    if (this.Artist) {
      return {
        // about page browser title
        title: this.Artist.name,
        meta: [
          { vmid: 'ogtitle', property: 'og:title', itemprop: 'name', content: `${this.Artist.name} | PhotoVogue Festival 2020` }
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>

h1 {
  opacity: 0;
  transform: translateY(80px);

  @include breakpoint(md-and-up) {
    //margin-top: -7vw;
  }
}

.social,
.content {
  opacity: 0;
  transform: translateY(80px);
}

.prev-artist-btn,
.next-artist-btn {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  max-width: 180px;
  height: unset !important;

  ::v-deep .v-btn__content {
    white-space: break-spaces;
    flex: 0 1 auto !important;
  }
}

::v-deep .clip-mask {
  opacity: 0;
}

::v-deep .scrolling-content {
  // padding-top: 100px;

  @include breakpoint('md-and-up') {
    // padding-top: 50vh;
  }
}

.artist-content {
  position: relative;
  margin-top: 25vh;

  @include breakpoint('md-and-up') {
    margin-top: 38.5vh;
  }
}

.prev-artist-btn {
  text-align: left;
  left: 30px;
}

.next-artist-btn {
  text-align: right;
  right: 30px;
}

</style>
